import CtaLayout from '@components/CtaLayout';
import Divider from '@components/Divider';
import Header from '@components/Header';
import Loading from '@components/Loading';
import useItem from '@hooks/item/useItem';
import useShop from '@hooks/shop/useShop';
import useAppCustom from '@hooks/useAppCustom';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import DefaultOptions from './components/DefaultOptions';
import ExpandedPersonalOptions from './components/ExpandedPersonalOptions';
import ItemFooter from './components/ItemFooter';
import ItemHeader from './components/ItemHeader';
import ItemInfo from './components/ItemInfo';
import PersonalOptionButton from './components/PersonalOptionButton';
import Recommendation from './components/Recommendation';
import usePrepareOrder from './hooks/usePrepareOrder';

interface Params {
    itemId: string;
    shopId: string;
}

const ItemActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
    const { itemId, shopId } = params;
    const item = useItem(itemId);
    const shop = useShop(shopId);
    const { itemOrderButtonPosition } = useAppCustom().item;
    const { t } = useTranslation('item');
    usePrepareOrder({ itemId, shopId });

    if (item && shop) {
        const { defaultOptionGroups, personalOptionGroups, isSoldOut } = item;
        return (
            <AppScreen >
                <CtaLayout
                    footerPosition={itemOrderButtonPosition}
                    footer={<ItemFooter item={item} shopId={shopId} isSoldOut={isSoldOut} />}
                    header={<ItemHeader shopId={shopId} itemId={itemId} />} >
                    <ItemInfo item={item} shopId={shopId}/>
                    <DefaultOptions
                        itemId={itemId}
                        optionGroups={defaultOptionGroups} />
                    <Divider/>
                    <PersonalOptionButton
                        itemId={itemId}
                        personalOptionGroups={personalOptionGroups} />
                    <ExpandedPersonalOptions
                        optionGroups={personalOptionGroups}
                        itemId={itemId} />
                    <Recommendation shopId={shopId} itemId={itemId} />
                </CtaLayout>
            </AppScreen>
        );
    }

    return (
        <AppScreen>
            <Header title={t('header.title')} />
            <Loading/>
        </AppScreen>
    );
};

export default ItemActivity;
